<template>
  <div class="content">
    <NavBar />
    <v-main>
      <v-container fluid>
        <div class="content-main">
          <v-card class="profile bg-white" title="Perfil">
            <v-card-text>
              <ProfileModule />
            </v-card-text>
          </v-card>
          <v-card class="main pa-5" title="Mis certificados">
            <v-card-text>
              <div>A continuación, gestiona tus procesos de formación y tus certificados.</div>
              <v-data-table :items="formation" :headers="headers" density="compact">
                <template v-slot:item="{ item }">
                  <tr>
                    <td>{{ item.matricula }}</td>
                    <td>{{ item.ruta }}</td>
                    <td>
                      <div class="d-flex align-center">
                        <v-progress-linear :model-value="item.asistencias" :height="9" :max="item.sesiones" color="amber" />
                        <div class="ms-4 text-caption">{{ item.asistencias }}/{{ item.sesiones }}</div>
                      </div>
                    </td>
                    <td class="text-center">{{ item.estado_formacion }}</td>
                    <td class="text-right">{{ filters.formatDate(item.certificate) }}</td>
                    <td class="text-center">
                      <div v-if="item.estado_formacion == 'cualificado'">
                        <v-btn size="small" variant="flat" text="Descargar" @click="download(item.matricula)"/>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <v-card class="skills" title="Mis Competencias">
            <v-card-text>
              <SkillModuleVue />
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </v-main>
    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>

    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">success</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="success.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
    
    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
        <v-divider class="mb-4"></v-divider>
        <div class="text-end">
          <v-btn class="text-none" color="error" variant="flat" text="Aceptar" @click="error.state = false"/>
      </div>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
  import axios from 'axios';
  import Params from '@/models/params';
  import Filters from '@/models/filters';
  import NavBar from '../components/navbar/NavBar';
  import ProfileModule from '../components/profile/ProfileModule';
  import SkillModuleVue from '@/components/profile/SkillModule.vue';
  import { ref, reactive, onMounted } from "vue";

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const formation = ref([])

  const process = ref(true)
  const params = ref(new Params)
  const filters = ref(new Filters)
  
  const headers = ref([
    { title: 'Nro. Matrícula', key: 'matricula', align: 'start' },
    { title: 'Ruta', key: 'ruta', align: 'start' },
    { title: 'Progreso Asistencias/Sesiones', key: 'matricula', align: 'center' },
    { title: 'Estado', key: 'estado_formacion', align: 'center' },
    { title: 'Fecha Certificación', key: 'certificate', align: 'end' },
    { title: 'Certificado', key: 'matricula', align: 'center' }
  ])

  async function load(){
    const frm = new FormData;
    frm.append("action", "data");
    frm.append("object", "loadformation");
    frm.append("value", localStorage.document);
    frm.append("token", localStorage.tokenaccess);
    const result = await eject(frm);
    process.value = false;
    if(result.status){
      formation.value = result.data;
    }else{
      error.text = 'Error al cargar los datos de formación';
      error.state = true;
    }
  }

  function download(matricula){
    const host = params.value.host;
    window.open(host + '/generarpdf/certificados/?token='+localStorage.tokenaccess+'&enroll='+matricula+'&document='+localStorage.document);
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'beneficiario.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(()=>{
    load();
  })
</script>